

















































































import { default as Component } from 'vue-class-component';
import NonCommodityProductFacade from '@/models/NonCommodityProductFacade';
import NonCommodityContractWidget from '@/components/widgets/NonCommodityContractWidget.vue';
import ContractAddressWidget from './ContractAddressWidget.vue';
import PaymentWidget from './PaymentWidget.vue';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Format from '@/interfaces/Format';
import ThgServiceElliDefault from '@/models/thg/ThgServiceElliDefault';
import ProductData from '@/interfaces/ProductData';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  components: {
    'address-widget': ContractAddressWidget,
    'payment-widget': PaymentWidget
  },
  filters: {
    zip: formatProvider.zip(),
    euro: formatProvider.euro()
  }
})
export default class ContractWidget extends NonCommodityContractWidget {
  public keyPhrasesWhichRequirePaymentData = ['praemie', 'prämie'];

  get productPrice(): number | undefined {
    return this.thgConfig.isCustomerTypeBusiness
      ? this.nonCommodityProduct.getBasePrice(
          this.$store.getters.getSelectedVehicleType,
          this.thgConfig.selectedYearArray
        )
      : this.nonCommodityProduct.getBasePriceBrutto(
          this.$store.getters.getSelectedVehicleType,
          this.thgConfig.selectedYearArray
        );
  }

  protected get nonCommodityProductPrice(): number {
    return this.productPrice ?? 0;
  }

  get formattedProductPrice(): string {
    return formatProvider.euro()(this.nonCommodityProductPrice);
  }

  public get minimumAgeRequired(): number {
    return 18;
  }

  get isProductUnvailable(): boolean {
    if (this.isFleetFlow) {
      return false;
    }
    return (
      this.sessionState.business == 1 &&
      !NonCommodityProductFacade.isProductAvailableForBusiness(this.store.state.nonCommodityProductData.productCode)
    );
  }

  get yearlyPrice() {
    return (getSelectedVehicleType, selectedYear) => {
      return this.thgConfig.isCustomerTypeBusiness
        ? this.nonCommodityProduct.getBasePrice(getSelectedVehicleType, [selectedYear])
        : this.nonCommodityProduct.getBasePriceBrutto(getSelectedVehicleType, [selectedYear]);
    };
  }

  protected get product(): ProductData {
    return this.store.state.nonCommodityProductData;
  }

  public get nonCommodityProduct(): NonCommodityProductFacade {
    return NonCommodityProductFacade.withData(this.product);
  }

  public get thgConfig(): ThgServiceElliDefault {
    return ThgServiceElliDefault.instance;
  }
}
